export const isFunction = (func: any): boolean => {
  return typeof func === "function";
};
